import { cast, clone, Instance, types } from 'mobx-state-tree'

import { FilterType } from './FilterType'

const FilterSelectOptionModel = types.model('FilterSelectOptionModel').props({
  value: types.string,
  text: types.string,
})

export const SELECT_OPTION_ALL_VALUE = '__all__'

// The possible icons for select filters. We separate this from the SVG declarations itself.
export enum SelectFilterIcon {
  User = 'user',
  Vehicle = 'vehicle',
  Checklist = 'checklist',
  Filter = 'filter',
  UserRole = 'user_role',
  Status = 'status'
}

export const SelectFieldFilterModel = types
  .model('SelectFieldFilterModel')
  .props({
    type: types.literal(FilterType.SELECT),
    icon: types.enumeration('SelectFilterIcon', Object.values(SelectFilterIcon)),
    allValuesText: types.maybe(types.string),
    fieldNetworkName: types.maybe(types.string),
    // We could use types.reference(FilterSelectOptionModel) here, but it would require adding an identifier field to FilterSelectOptionModel, and this starts being a mess (since we would need to add fieldName in there to preserve uniqueness).
    filterValue: types.maybe(FilterSelectOptionModel),
    options: types.array(FilterSelectOptionModel),
  })
  .actions((self) => ({
    setFilterValue(value: string | undefined) {
      const selectedOption = self.options.find((option) => option.value === value)
      // We clone  the option because managing references and identifier is a bit of a mess
      self.filterValue = selectedOption ? clone(selectedOption) : undefined
    },
    setOptions(options: { value: string; text: string }[]) {
      self.options = cast(options)
    },
  }))
  .views((self) => 
    {
      const allOption = FilterSelectOptionModel.create({
        text: self.allValuesText ?? 'All', 
        value: SELECT_OPTION_ALL_VALUE
      })
      return {
        get allValuesSelectOption(): FilterSelectOption {
          return allOption
        } ,
        get selectOptions(): Array<FilterSelectOption> {
          return [allOption, ...self.options]
        },
        get getFilterAsUrlParam(): string {
          if (self.fieldNetworkName === undefined) {
            throw Error('Filter must have fieldNetworkName if present in URL params')
          }
          return self.filterValue ? `${self.fieldNetworkName}=${self.filterValue.value}` : ''
        }
      }
  })

export type FilterSelectOption = Instance<typeof FilterSelectOptionModel>
export type SelectFieldFilter = Instance<typeof SelectFieldFilterModel>
